module.exports = __webpack_public_path__ + "img/dollar.43c1836a.svg";